import React from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { VAPermissions } from 'Utils/constants'
import { ListPaymentTypes } from '../ListPaymentType'
import { Formatter } from 'Utils/Formatter'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'
import { useTotalMargin } from 'Hooks/useTotalMargin'
import { marginTotal } from 'Utils/functions'
import useValidatePermission from 'Hooks/useValidatePermission'

export const PaymentType = ({ payments }) => {
  const { sellOrderPostData, isCommercialCreditSelected } = useSelector(
    state => state.sellOrder
  )

  const [visibilityCostMargin, setVisibilityCostMargin] = React.useState(true)

  const seeMargenProd = useValidatePermission(VAPermissions.seeMargenProd)
  const { totalPrice, totalCost } = useTotalMargin(
    sellOrderPostData?.Data?.SalesDocumentInfo?.Lines
  )
  const { Amount, Tax, AmountWithTax, Origin, CreditAccountNumber } =
    sellOrderPostData?.Data?.SalesDocumentInfo || {}

  const isWebDocument = Origin === 'AB'
  const showPayments = isWebDocument ? !!payments?.length : !!AmountWithTax
  const creditAccountNumber =
    CreditAccountNumber ||
    isCommercialCreditSelected?.accountItemSelected?.CreditAccountNumber

  return (
    <div style={{ display: 'flex', gap: '16px' }}>
      <div style={{ ...styles.containerStyles, width: '60%' }}>
        {showPayments && (
          <>
            <p style={{ fontSize: '14px', fontWeight: '600' }}>
              Métodos de pago
            </p>
            {!isWebDocument && creditAccountNumber && (
              <p style={{ fontSize: '14px' }}>
                Crédito Comercial {creditAccountNumber}: $
                {Formatter.Money(AmountWithTax, {
                  rounded: true,
                  decimalPrecision: 2,
                })}
              </p>
            )}
            {!isWebDocument && !creditAccountNumber && (
              <p style={{ fontSize: '14px' }}>
                Contado: $
                {Formatter.Money(AmountWithTax, {
                  rounded: true,
                  decimalPrecision: 2,
                })}
              </p>
            )}
            <ListPaymentTypes payments={payments} />
          </>
        )}
      </div>
      <div style={{ ...styles.containerStyles, width: '40%' }}>
        <div style={styles.priceStyles}>
          <h3 style={{ fontSize: '14px' }}>Sub Total</h3>
          <p style={{ fontSize: '14px', marginRight: 15 }}>
            ${Formatter.Money(Amount)}
          </p>
        </div>
        <div style={styles.priceStyles}>
          <h3 style={{ fontSize: '14px' }}>ITBMS</h3>
          <ToolTipAmount amount={Tax} />
        </div>
        {seeMargenProd && (
          <div style={styles.priceStyles}>
            <h3 style={{ fontSize: '14px', fontWeight: '600' }}>
              Margen total
            </h3>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}>
              <span style={{ fontSize: '14px' }}>
                {visibilityCostMargin
                  ? '****'
                  : `${marginTotal(totalCost, totalPrice).toFixed(2)}%`}
              </span>

              <span
                style={{ cursor: 'pointer', fontSize: '14px' }}
                onClick={() => setVisibilityCostMargin(prev => !prev)}>
                <FontAwesomeIcon
                  icon={visibilityCostMargin ? faEyeSlash : faEye}
                />
              </span>
            </div>
          </div>
        )}
        <div style={styles.priceStyles}>
          <h3 style={{ fontSize: '14px', fontWeight: '600' }}>Total</h3>
          <ToolTipAmount amount={AmountWithTax} />
        </div>
      </div>
    </div>
  )
}

const styles = {
  containerStyles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    background: '#FFFFFF',
    borderRadius: '5px',
    marginTop: '15px',
    boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.14)',
    padding: '16px 53px',
    height: 'auto',
  },
  priceStyles: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '8px',
    width: '100%',
  },
}
